import type { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

export default function InputError({
  message,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { message?: string | string[] }) {
  if (!message) return null

  const errorText = Array.isArray(message) ? message[0] : message

  return errorText ? (
    <p {...props} className={cn("text-sm text-red-400", className)}>
      {errorText}
    </p>
  ) : null
}
